export default "__VITE_ASSET__385d6eb4__"